import { TextSpan } from '../../../Atoms/Text';

const PILL_CLASSES = 'rounded px-1.5 py-0.5 whitespace-nowrap';

/** "Adjusted" when the user's rating differs from the client average; "Wide spread" when clients disagree by 30+. */
export const ScoringPills = ({ adjusted, wideSpread }: { adjusted: boolean; wideSpread: boolean }) => (
  <>
    {adjusted && (
      <TextSpan
        size="xs"
        color="amber"
        className={`${PILL_CLASSES} bg-amber-50`}>
        Adjusted
      </TextSpan>
    )}
    {wideSpread && (
      <TextSpan
        size="xs"
        color="grey8"
        className={`${PILL_CLASSES} bg-grey-1`}>
        Wide spread
      </TextSpan>
    )}
  </>
);
